<template>
    <div class="modal" :id="id">
        <div class="modal-content">
            <div class="row">
                <span class="close">&times;</span>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <h3>{{$t('page.product.view.stock_change')}}</h3>

                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.product.view.storage')}}</label>
                        <div class="col-md-8">
                            <input type="text" class="form-control" v-model="item.storage" readonly />
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.product.view.rack')}}</label>
                        <div class="col-md-8">
                            <input type="text" class="form-control" v-model="item.rack" readonly />
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.product.view.storage_place')}}</label>
                        <div class="col-md-8">
                            <input type="text" class="form-control" v-model="item.storagePlace" readonly />
                        </div>
                    </div>

                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.product.view.stock')}}</label>
                        <div class="col-md-8">
                            <input type="text" class="form-control" v-model="item.stock" />
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.product.view.stock_reserved')}}</label>
                        <div class="col-md-8">
                            <input type="text" class="form-control" v-model="item.stockReserved" readonly />
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.product.view.stock_net')}}</label>
                        <div class="col-md-8">
                            <input type="text" class="form-control" :value="item.stock - item.stockReserved" readonly />
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.product.view.reorder_level')}}</label>
                        <div class="col-md-8">
                            <input type="text" class="form-control" v-model="item.reorder_level" />
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-4 control-label">Verpackungstyp</label>
                        <div class="col-md-8">
                            <select class="form-control" ref="packagingType" v-model="item.packaging_type">
                                <option v-for="packagingType in packagingTypes" :value="packagingType.id">{{packagingType.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-4 control-label">Faktor</label>
                        <div class="col-md-8">
                            <double-input-spinner :min-value="0" :max-value="9999" :step-size="0.1" v-model="item.wrapping_factor" />
                        </div>
                    </div>

                </div>
            </div>
            <div class="row">
                <div class="col-md-offset-6 col-md-6">
                    <button class="form-control" @click="sendRebook">{{$t('page.product.view.stock.update')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NumberInputSpinner from "../utils/NumberInputSpinner";
    import DoubleInputSpinner from "../utils/DoubleInputSpinner";

    export default {
        name: "EditStockModal",
        components: {
            NumberInputSpinner,
            DoubleInputSpinner,
        },
        data: function() {
            return {
                componentKey: 0,
                productId: BigInt,
                storagePlaceId: BigInt,
                maxStock: BigInt,
                warehouses: [],
                storages: [],
                racks: [],
                storagePlaces: [],

                selectedPackagingType: Number,
                packagingTypes: [],
                item: Object,
                index: Number,
            }
        },
        props: {
            id: String,
        },
        methods: {
            setItem: function(item, index){
                this.item = item;
                this.index = index;
            },
            setPackagingTypes: function(types){
                this.packagingTypes = types;
            },

            sendRebook: function () {
                let warehouses = this.$refs[this.$id('warehouses')];
                let storages = this.$refs[this.$id('storages')];
                let racks = this.$refs[this.$id('racks')];
                let places = this.$refs[this.$id('places')];
                let quantity = parseInt(this.$refs[this.$id('quantity')].value);

                if( (parseInt(warehouses.value) < 0) ||
                    (parseInt(storages.value) < 0) ||
                    (parseInt(racks.value) < 0) ||
                    (parseInt(places.value) < 0) ||
                    (quantity <= 0)){
                    return;
                }

                $('.loading-screen').addClass('active');
                axios.post('/article/' + this.productId + '/storage/rebook', {
                        oldStoragePlaceId: this.storagePlaceId,
                        storagePlaceId: parseInt(places.value),
                        quantity: quantity
                }).then(function (data) {
                    vue.$emit('changedProduct', true);
                }).finally(function () {
                    $('.loading-screen').removeClass('active');
                })
            },
        }

    }
</script>

<style scoped>

</style>